export function beforeHook(event: string, context: string): string {
  return `await runBeforeHooks('${event}', ${context})`
}
